import StrokedRoundedLinkIcon from "@/components/icons/StrokedRoundedLinkIcon.vue";
export default {
  name: 'HoverableImage',
  props: {
    image: String,
    width: {
      type: String,
      default: '32'
    },
    height: {
      type: String,
      default: '32'
    },
    active: Boolean
  },
  components: {
    StrokedRoundedLinkIcon
  }
};